<template>
  <div>
    <div class="toolbtn flex">
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
    </div>
    <!-- 内容 -->
    <div class="width100 backwhite alldigitals">
      <div
        class="width100 text-ellipsis backwhite pad-bot20 border-rd3"
        v-if="total != 0"
      >
        <div
          class="
            f14
            lineheight35
            pad-left20 pad-right20 pad-top20 pad-bot10
            bordert-tf
            dimencont
          "
          v-for="(item, index) in pages"
          :key="index"
        >
          <p class="f14 flex-betweennowrap cursorpointer dimensional">
            <span @click="toPatentdatails(index)"
              >{{ item.title }}({{ item.appNumber }})
              <span
                class="f12"
                :class="
                  item.dbName == '实用新型'
                    ? 'patensy'
                    : item.dbName == '外观专利'
                    ? 'patenwg'
                    : item.dbName == '发明专利'
                    ? 'patenzl'
                    : item.dbName == '发明授权'
                    ? 'patensq'
                    : ''
                "
                >{{ item.dbName }}</span
              ></span
            >
          </p>
          <p
            class="width70 flex-betweennowrap pad-top10"
            @click="toPatentdatails(index)"
          >
            <span>公开(公告)号:{{ item.pubNumber }}</span>
            <span>申请（专利权）人：{{ item.patentee }}</span>
            <span> 发明（设计）人：{{ item.inventroName }}</span>
          </p>
          <p class="width70 flex-betweennowrap">
            <span>国省代码:{{ item.proCode }}</span>
            <span>申请日:{{ item.appDate }} </span>
            <span>公开(公告)日:{{ item.pubDate }}</span>
          </p>
          <p>分类号:{{ item.ipc }}</p>
          <p>主分类号:{{ item.mainIpc }}</p>
        </div>
        <!-- 分页 -->
        <div
          v-if="total != 0"
          class="
            flex-betweennowrap
            pad-top20 pad-bot20
            pagination
            pad-right10
            bordert-tf
          "
        >
          <span></span>
          <el-pagination
            :hide-on-single-page="true"
            @size-change="handleSizeChange"
            @current-change="currentchange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="per_page"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <div
      class="width100 margin-auto backgroudFFF margin-top15"
      v-if="total == 0"
    >
      <el-empty
        :image="require('@/assets/barsvg/zwsj@3x.png')"
        :image-size="200"
        description="抱歉，没有搜到您想要的内容"
        class="heightempty"
      >
        <p style="position: relative; bottom: 60px" class="f14">暂无数据</p>
      </el-empty>
    </div>

    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { patentquerykey } from "@/api/patent/patent.api";
import callback from "@/components/callback.vue";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      thisNum: 1,
      pages: [],
      total: 0,
      per_page: 0,
      pagination: false,
      currentPage: 0,
    };
  },
  components: {
    callback,
  },
  methods: {
    toPatentdatails(index) {
      window.sessionStorage.setItem(
        "technicalKey",
        this.pages[index].appNumber
      );
      this.$router.push({ path: "/development-Administration/View-details" });
    },
    refresh() {
      this.$loading.show(); // 显示loading
      patentquerykey({
        keyword:
          window.sessionStorage.getItem("technicalkeyword") == null
            ? "!"
            : window.sessionStorage.getItem("technicalkeyword"),
        page: this.thisNum,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pagination = true;
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.pages.forEach((i) => {
            if (i.dbName == "SYXX") {
              i.dbName = "实用新型";
            }
            if (i.dbName == "FMZL") {
              i.dbName = "发明专利";
            }
            if (i.dbName == "WGZL") {
              i.dbName = "外观专利";
            }
            if (i.dbName == "FMSQ") {
              i.dbName = "发明授权";
            }
          });
        } else {
          this.$loading.hide(); // 隐藏loading
          this.drawer = false;
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },

    // 第一个分页
    currentchange(val) {
      patentquerykey({
        // keyword: this.ruleForm.crux,
        keyword: window.sessionStorage.getItem("technicalkeyword"),
        page: val,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.pages.forEach((i) => {
            if (i.dbName == "SYXX") {
              i.dbName = "实用新型";
            }
            if (i.dbName == "FMZL") {
              i.dbName = "发明专利";
            }
            if (i.dbName == "WGZL") {
              i.dbName = "外观专利";
            }
            if (i.dbName == "FMSQ") {
              i.dbName = "发明授权";
            }
          });
        } else {
          this.drawer = false;
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChange(val) {
      patentquerykey({
        // keyword: this.ruleForm.crux,
        keyword: window.sessionStorage.getItem("technicalkeyword"),
        page: 1,
        limit: val,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.pages.forEach((i) => {
            if (i.dbName == "SYXX") {
              i.dbName = "实用新型";
            }
            if (i.dbName == "FMZL") {
              i.dbName = "发明专利";
            }
            if (i.dbName == "WGZL") {
              i.dbName = "外观专利";
            }
            if (i.dbName == "FMSQ") {
              i.dbName = "发明授权";
            }
          });
        } else {
          this.drawer = false;
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },
  created() {
    this.$loading.show(); // 显示loading
    patentquerykey({
      query_type: "like",
      title:
        window.sessionStorage.getItem("technicalkeyword") == null
          ? "!"
          : window.sessionStorage.getItem("technicalkeyword"),
      page: this.thisNum,
    }).then((res) => {
      if (res.data.code == 200) {
        this.pagination = true;
        this.$loading.hide(); // 隐藏loading
        this.pages = res.data.data.data;
        this.total = res.data.data.total;
        this.per_page = res.data.data.per_page;
        this.pages.forEach((i) => {
          if (i.dbName == "SYXX") {
            i.dbName = "实用新型";
          }
          if (i.dbName == "FMZL") {
            i.dbName = "发明专利";
          }
          if (i.dbName == "WGZL") {
            i.dbName = "外观专利";
          }
          if (i.dbName == "FMSQ") {
            i.dbName = "发明授权";
          }
        });
      } else {
        this.$loading.hide(); // 隐藏loading
        this.drawer = false;
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
<style scoped>
.alldigitals {
  max-height: 88vh;
  overflow-y: scroll;
}
.patensy {
  color: #7b83ea;
  padding: 2px 10px 2px 10px;
  /* opacity: 0.1; */
  background: #ebecf1;
  border-radius: 11px;
}
.patenwg {
  color: #52c5cb;
  padding: 2px 10px 2px 10px;
  /* opacity: 0.1; */
  background: #e1e5e6;
  border-radius: 11px;
}
.patenzl {
  color: #f96d68;
  padding: 2px 10px 2px 10px;
  /* opacity: 0.1; */
  background: #e9e2e1;
  border-radius: 11px;
}
.patensq {
  color: #5599ff;
  padding: 2px 10px 2px 10px;
  /* opacity: 0.1; */
  background: #eaebee;
  border-radius: 11px;
}
.patenbtn {
  background: #678feb;
  color: #f9f9f9;
  padding: 2px 10px 2px 10px;
}
.borderbot {
  border-bottom: 1px solid #efefef;
  width: 96%;
  margin: 10px auto 0;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>